import { RootState } from 'rootReducer';

export const bookingModalSelector = (state: RootState) => state.commonReducer.bookingModalReducer;
